export default __webpack_public_path__ + "static/media/Flag_of_Mongolia.fef0502c.svg";